import * as React from 'react';

import {Button} from 'shells/button/button';
import {FooterBar} from 'shells/modal/footer-bar';
import {Modal} from 'shells/modal/modal';

import styles from './form-publish-modal.module.css';

type Props = {
    onClose: () => void;
    onPublish: () => void;
};

export function MeetingFormPublishModal(props: Props) {
    return (
        <Modal
            onClose={props.onClose}
            isOpen={true}
            headerText='Publish all changes'
            closeButton={false}
            maxHeight={220}
            maxWidth={350}
        >
            <div className={styles.content}>
                This will update your meeting wherever it’s embedded and shared.
            </div>
            <FooterBar
                left={
                    <Button
                        variant='text-secondary'
                        size='big'
                        onClick={props.onClose}
                        noPadding={true}
                    >
                        Close
                    </Button>
                }
                right={
                    <Button variant='primary' size='big' onClick={props.onPublish}>
                        Publish changes
                    </Button>
                }
                absolutePosition={true}
            />
        </Modal>
    );
}
